import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data("signInLink", (email) => ({
  email,
  expanded: false,
  validateEmail () {
    client.get(`/validate_email?session[email]=${this.email}`)
      .then(({ sign_in_link_enabled }) => {
        this.expanded = sign_in_link_enabled
      })
  }
}))
